export default {
  country_locale: 'de-CH',
  wia_title: 'Web basierte Selbsthilfe',
  wia_need_help: 'Ich brauche Hilfe für',
  wia_model_name: 'Produktname',
  wia_back: '< zurück',
  wia_confirm: 'Bestätigen',
  wia_issue_search: 'Was ist Ihr Problem?',
  wia_issue_description: 'Bitte beschreiben Sie kurz das Hauptproblem Ihres Gerätes',
  wia_issue_placeholder: 'Bsp: Wasseraustritt unten',
  wia_issue_generic_macro_category: 'Generali',
  wia_issue_no_results: 'Kein Ergebnis gefunden',
  wia_issue_search_label: 'Cerca',
  wia_issue_title: 'manuelle Suche',
  wia_issue_concern: 'Welches Problem ist aufgetaucht?',
  wia_issue_specific: 'Weitere Details',
  wia_possible_solution: 'Mögliche Lösungen',
  wia_solved_issue: 'Ist Ihr Problem gelöst?',
  wia_closed: 'Schließen X',
  wia_feedback_ok: ' Ja!',
  wia_find_another_solution: 'Eine andere Lösung finden',
  wia_feedback_title: 'Es freut uns, dass Ihr Problem gelöst wurde!',
  wia_feedback_text1: 'Besuchen Sie unseren Shop. Wir haben besondere Angebote für Sie',
  wia_feedback_text2: 'Erfahren Sie mehr über unsere brandneuen intelligenten Technologien',
  wia_smile_up_popup_text1: 'Entdecken Sie unsere Garantiepläne',
  wia_smile_down_popup_title: 'Benötigen Sie weitere Hilfe?',
  wia_smile_down_popup_text1: 'Gehen Sie zum zweiten Schritt',
  wia_smile_down_popup_or_text: 'oder',
  wia_smile_down_popup_text2: 'Reparaturtermin buchen',
  wia_need_more_help: 'Benötigen Sie weitere Hilfe?',
  wia_optional_label: '(optional)',
  wia_no_solution: 'Leider gibt es für Ihr Thema keine einfache Self-Service Lösung. Bitte klicken Sie hier für weitere Unterstützung.',
  wia_all_solution: 'Alle Ergebnisse',
  wia_all_categories: 'Alle Kategorien',
  wia_seo_l1_issue: 'Alle Fehler nach Kategorie',
  wia_seo_wp_country_name: '',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: '',
  wia_seo_id_country_name: 'CH',
  wia_seo_wp_meta_title: 'Probleme und Lösungen',
  wia_seo_bk_meta_title: 'Probleme und Lösungen',
  wia_seo_hp_meta_title: 'Probleme und Lösungen',
  wia_seo_id_meta_title: 'Probleme und Lösungen',
  wia_seo_wp_meta_description: '',
  wia_seo_bk_meta_description: '',
  wia_seo_hp_meta_description: '',
  wia_seo_id_meta_description: '',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
